import { makeStyles } from 'tss-react/mui';

export default makeStyles({ name: 'UserWidget' })({
    compact: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    },
    avatar: {
        width: 40,
        height: 40,
        boxSizing: 'border-box',
        borderRadius: 20,
        border: '1px solid #ECECEC',
        background: '#F6F5F4',
        color: '#8E8E8E',
        fontSize: 14,
        fontWeight: 500,
        cursor: 'pointer',
        transition: 'all 0.2s',
        ['&:hover']: {
            borderColor: '#E4E4E4',
            background: '#EBE8E5'
        }
    },
    regular: {
        display: 'flex',
        flexDirection: 'column',
        gap: 8,
        padding: 12,
        borderRadius: 20,
        border: '1px solid #E4E4E4',
        background: '#F6F5F4'
    },
    selector: {
        display: 'flex',
        flexDirection: 'column',
        padding: 8,
        gap: 16,
        borderRadius: 8,
        color: '#8E8E8E',
        border: '1px solid #E4E4E4',
        borderWidth: 1,
        borderStyle: 'solid',
        borderColor: '#F6F5F4',
        background: '#F6F5F4',
        transition: 'all 0.2s',
        cursor: 'pointer',
        ['&:hover']: {
            borderColor: '#E4E4E4',
            background: '#EBE8E5'
        }
    },
    line: {
        display: 'flex',
        alignItems: 'center',
        gap: 4
    },
    licenseName: {
        flex: 1,
        color: '#232323',
        fontSize: 14,
        fontWeight: 500,
        lineHeight: '21px',
        letterSpacing: '-0.28px'
    }
});
